/**
 * EKSELENS360 family — the public source of truth for the "12 lenses + 1 engine"
 * story. Composed from subBrands.js (codes/taglines), the service slugs and the
 * public no-login lite-assessment slugs (/resources/<liteSlug>-self-assessment).
 *
 * Branding unchanged — this is data only; pages render it with the existing
 * `ek-` design tokens.
 */

// The reinvention engine — the 13th toolset, hero of the family.
export const ENGINE = {
  code: "ENTERPRISE360",
  name: "The Reinvention Engine",
  tagline: "One engine that ties the twelve lenses together.",
  blurb:
    "Classifies a business by archetype, applies sector & complexity overlays, " +
    "and assembles a tailored, function-by-function reinvention blueprint — with " +
    "editable end-to-end process maps.",
  path: "/enterprise360",
  sectors: 21,
  archetypes: 20,
};

// The twelve specialist lenses.
export const LENSES = [
  { code: "AI360", icon: "Cpu", name: "AI Readiness & Adoption",
    tagline: "AI readiness, governance & adoption.",
    serviceSlug: "ai-readiness-and-adoption", liteSlug: "ai360" },
  { code: "DIGITAL360", icon: "MonitorSmartphone", name: "Digital & Technology Transformation",
    tagline: "Technology transformation, end to end.",
    serviceSlug: "digital-and-technology-transformation", liteSlug: "digital360" },
  { code: "PMO360", icon: "GanttChartSquare", name: "Project, Programme & PMO Improvement",
    tagline: "Programme & PMO uplift that drives decisions.",
    serviceSlug: "project-programme-and-pmo-improvement", liteSlug: "pmo360" },
  { code: "CHANGE360", icon: "Users", name: "Business Change & Adoption",
    tagline: "Adoption is the outcome — not communication.",
    serviceSlug: "business-change-and-adoption", liteSlug: "change360" },
  { code: "OPERATING360", icon: "Workflow", name: "Service & Operating-Model Transformation",
    tagline: "Designing the way the business works.",
    serviceSlug: "service-and-operating-model-transformation", liteSlug: "operating360" },
  { code: "SUPPLIER360", icon: "GitBranch", name: "Supplier & Technology Value Optimisation",
    tagline: "Surface savings; remove renewal risk.",
    serviceSlug: "supplier-and-technology-value-optimisation", liteSlug: "supplier360" },
  { code: "ITSM360", icon: "ServerCog", name: "IT Service Management & Operational Excellence",
    tagline: "From firefighting to proactive service management.",
    serviceSlug: "it-service-management-and-operational-excellence", liteSlug: "itsm360" },
  { code: "DATA360", icon: "LineChart", name: "Data, Insight & Performance",
    tagline: "Data that drives decisions, not dashboards.",
    serviceSlug: "data-insight-and-performance", liteSlug: "data360" },
  { code: "BENEFITS360", icon: "Target", name: "Benefits Realisation & Assurance",
    tagline: "Promised benefits, evidenced and realised.",
    serviceSlug: "benefits-realisation-and-assurance", liteSlug: "benefits360" },
  { code: "GOVERN360", icon: "ShieldCheck", name: "Governance & Delivery Control",
    tagline: "Decision rights and delivery confidence.",
    serviceSlug: "governance-and-delivery-control", liteSlug: "govern360" },
  { code: "CAPABILITY360", icon: "GraduationCap", name: "Capability & Training-Needs Analysis",
    tagline: "Capability the business actually needs.",
    serviceSlug: "capability-and-training-needs-analysis", liteSlug: "capability360" },
  { code: "STAKEHOLDER360", icon: "MessagesSquare", name: "Stakeholder Engagement & Communications",
    tagline: "Internal alignment that survives go-live.",
    serviceSlug: "stakeholder-engagement-and-communications", liteSlug: "stakeholder360" },
];

export const liteRoute = (liteSlug) => `/resources/${liteSlug}-self-assessment`;
export const FAMILY_COUNT = LENSES.length + 1; // 13
